import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { QuoteCard } from '../quote_card';
import { getLabelFromCode, getColourLabel, getProductCategory } from '../../../../../core/state_selectors';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

const _CarDetails =  (props) => {
    const { make, year, model, body, transmission, fuel, colour, description, coverType } = props;
    return (
        <QuoteCard title="Car details" path="car_make">
            <QuoteQuestionPlainItem title="Car" content={`${make}, ${model} | ${year} | ${body} | ${transmission} | ${fuel}`} />
            <QuoteQuestionPlainItem title="Series" content={description} />
            <QuoteQuestionPlainItem title="Colour" content={colour} />
            <QuoteQuestionPlainItem title="Cover type" content={coverType || ''} />
        </QuoteCard>
    );
};

_CarDetails.propTypes = {
    make: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    transmission: PropTypes.string.isRequired,
    fuel: PropTypes.string.isRequired,
    colour: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    coverType: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        make: getLabelFromCode(state, 'coverDetail.vehicle.make', 'vertical.quote.apiResponses.makes') || 'Make',
        year: getLabelFromCode(state, 'coverDetail.vehicle.year', 'vertical.quote.apiResponses.years') || 'Year',
        model: getLabelFromCode(state, 'coverDetail.vehicle.model', 'vertical.quote.apiResponses.models') || 'Model',
        body: getLabelFromCode(state, 'coverDetail.vehicle.body', 'vertical.quote.apiResponses.bodies') || 'Body',
        transmission: getLabelFromCode(state, 'coverDetail.vehicle.transmission', 'vertical.quote.apiResponses.transmissions') || 'Transmission',
        fuel: getLabelFromCode(state, 'coverDetail.vehicle.fuel', 'vertical.quote.apiResponses.fuel') || 'Fuel',
        colour: getColourLabel(state) || 'Colour',
        description: state.getIn('vertical.quote.apiResponses.description'.split('.')) || 'Description',
        coverType: getProductCategory(state)
    };
};

const CarDetails = connect(mapStateToProps)(_CarDetails);

export { CarDetails, _CarDetails };
